import {
  MedicareBridgeChecklistItem,
  MedicareBridgeResponseValue,
} from './medicare-bridge.types';

/** Matches the platform rule: a hidden parent does not reveal its follow-up. */
export function isChecklistItemApplicable(
  item: MedicareBridgeChecklistItem,
  responses: Record<string, MedicareBridgeResponseValue>,
  items: MedicareBridgeChecklistItem[],
): boolean {
  const when = item.requiredWhen;
  if (!when) return true;
  const source = items.find((entry) => entry.key === when.key);
  if (
    source?.requiredWhen &&
    !isChecklistItemApplicable(source, responses, items)
  ) {
    return false;
  }
  const other = responses[when.key];
  if (when.numberGte != null || when.numberLt != null) {
    const numeric = typeof other === 'number' ? other : Number(other);
    if (typeof other !== 'number' && typeof other !== 'string') return false;
    if (!Number.isFinite(numeric)) return false;
    if (when.numberGte != null && numeric < when.numberGte) return false;
    if (when.numberLt != null && numeric >= when.numberLt) return false;
    return true;
  }
  const values = Array.isArray(other)
    ? other
    : typeof other === 'string'
      ? [other]
      : [];
  return (when.includesAny ?? []).some((value) => values.includes(value));
}
